
import { Prop } from 'vue-property-decorator'
import { Vue, Options } from 'vue-class-component'
import ModalRightFullPageOptions from '@/interfaces/modal-right-full-page-options'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faChevronLeft)

@Options({
  components: {
    FontAwesomeIcon
  }
})
export default class ModalRightFullPage extends Vue {
  @Prop() modalOptions!: ModalRightFullPageOptions
  @Prop() onClose!: () => void
  
  private isClose = false

  closeModal() {
    this.isClose = true
    setTimeout(() => {
      this.onClose()
    }, 500)
  }
}
